import * as React from "react";
import "./product.css";

const Product = (props) => {
    const {name, price, image, onClick, index} = props;
    return (
        <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
            <div className="box_main">
                <h4 className="shirt_text">{name}</h4>
                <p className="price_text">Price <span style={{color: "#262626"}}>$ {price}</span></p>
                <div className="tshirt_img">
                    <img src={image} style={{height: "250px", cursor: "pointer"}}
                         onClick={() => onClick({name, price, image})} alt={name}/>
                </div>
                <div className="btn_main">
                    <div>
                        <button tab-index='0' aria-label="Buy Now" onClick={() => onClick({name, price, image})} className="btns buy_bt">Buy Now</button>
                    </div>
                </div>
            </div>
        </div>
    );

};


export default Product;
